import * as yup from "yup";

const schema = yup.object().shape({
  goalName: yup
    .string()
    .min(3, "Minimum 3 characters")
    .max(45, "Maximum 45 characters")
    .required("Name is required"),

  goalType: yup.string().required("Type is required"),

  goalValue: yup.number().typeError("Value must be a number").required("Value is required"),

  goalGroup: yup.string().required("Group is required"),

  goalTooltip: yup.string().required("Tooltip is required"),
});

export default schema;
